module.exports = __webpack_public_path__ + "static/img/6.5bbbc19.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/6.png
// module id = ZqMv
// module chunks = 0